var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    "data-name": "Livello 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.52,15,26,20.52a1.43,1.43,0,0,0,2.06,0L33.46,15a1.5,1.5,0,0,0,0-2.1,1.47,1.47,0,0,0-2.07,0l-3.16,3.21V9.28h0V1.48a1.47,1.47,0,1,0-2.93,0V8.55h0v7.13l-2.72-2.75a1.44,1.44,0,0,0-2.06,0h0A1.49,1.49,0,0,0,20.52,15Z",
    transform: "translate(-14.99 0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2,10.85H37a.79.79,0,0,0-.79.8V29.19H17.77V11.65a.79.79,0,0,0-.79-.8h-1.2a.79.79,0,0,0-.79.8V30.59A1.4,1.4,0,0,0,16.38,32H37.6A1.4,1.4,0,0,0,39,30.59V11.65A.79.79,0,0,0,38.2,10.85Z",
    transform: "translate(-14.99 0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.001915ca.svg";
export { ForwardRef as ReactComponent };